import { useMutation, type UseMutationResult, useQueryClient } from "@tanstack/react-query";

import useAuth from "src/hooks/useAuth";
import type { Id } from "src/types/id";
import { Mutation } from "src/types/mutation";
import type { Notification } from "src/types/notification";
import { Query } from "src/types/query";
import axios from "src/utils/axios";

export const useSawNotification = (): UseMutationResult<Notification, unknown, Id> => {
    const clientQuery = useQueryClient();
    const { user } = useAuth();

    return useMutation({
        mutationKey: [Mutation.SawNotification],

        mutationFn: async (notificationId: Id) => {
            const result = await axios.patch<{ notification: Notification }>(
                `/user/${user.id}/notification/${notificationId}`
            );
            return result.data.notification;
        },

        onSuccess: (notification) => {
            clientQuery.setQueryData([Query.Notifications, user.id], (old: Notification[]) => {
                return old.map((elm) => {
                    if (elm.id === notification.id) {
                        return {
                            ...notification,
                        };
                    }
                    return elm;
                });
            });
        },
    });
};

export const useSawNotifications = (): UseMutationResult<Notification[]> => {
    const clientQuery = useQueryClient();
    const { user } = useAuth();

    return useMutation({
        mutationKey: [Mutation.SawNotifications],

        mutationFn: async (notifications) =>
            (
                await axios.post<{ notifications: [Notification] }>(
                    `/user/${user.id}/notification`,
                    {
                        notifications,
                    }
                )
            ).data.notifications,

        onSuccess: (notifications) => {
            clientQuery.setQueryData([Query.Notifications, user.id], () => notifications);
        },
    });
};
